import { getPropertyImageUrl } from "@/config/api";
import { getCoverImageUrl } from "@/lib/imageMap";

export type UrgentPropertyImageFields = {
  property_id: number;
  property_image: string | null;
};

export function getUrgentCardImageFilename(a: UrgentPropertyImageFields): string | null {
  if (!a.property_image) return null;
  const raw = a.property_image.includes("/")
    ? a.property_image.split("/").pop() || ""
    : a.property_image;
  if (!raw) return null;
  return raw.startsWith("thumb/") ? raw.slice("thumb/".length) : raw;
}

export function getUrgentCardImageUrl(a: UrgentPropertyImageFields): string {
  if (a.property_image) {
    const raw = a.property_image.includes("/")
      ? a.property_image.split("/").pop() || ""
      : a.property_image;
    if (!raw) {
      return getCoverImageUrl({ id: a.property_id, images: [] }, true);
    }
    const thumbFile = raw.startsWith("thumb/") ? raw : `thumb/${raw}`;
    return getPropertyImageUrl(a.property_id, thumbFile);
  }
  return getCoverImageUrl({ id: a.property_id, images: [] }, true);
}
